// Links to localranker.fr used in calls to action.
//
// localranker.fr has no English demo page yet: English pages send visitors to
// the French one, tagged with utm_campaign so the leads can be told apart.
// When an English page exists, change DEMO_BASE_URL.en only.

const DEMO_BASE_URL = {
  fr: "https://localranker.fr/demander-demo",
  en: "https://localranker.fr/demander-demo",
};

const SITE_BASE_URL = {
  fr: "https://localranker.fr/",
  en: "https://localranker.fr/",
};

const utm = (lang, medium) => {
  const params = new URLSearchParams({ utm_source: "localranker.tech" });
  if (medium) params.set("utm_medium", medium);
  if (lang === "en") params.set("utm_campaign", "localranker-tech-en");
  return params.toString();
};

export const demoUrl = (lang, medium) => `${DEMO_BASE_URL[lang]}?${utm(lang, medium)}`;

export const siteUrl = (lang) => `${SITE_BASE_URL[lang]}?${utm(lang)}`;
